import * as React from "react";
import RequestAccess from "./request-access";
import FlatButton from "material-ui/FlatButton";
import { formatMessage } from "lib/globalize-util";
import MarketplaceContacts from "./marketplace-contacts";
import ContactButton from "./contact-button";
import RequestAccessButton from "./request-access-button";
import { merge, $, media, presets } from "glamor";
import Nuorder from "components/icons/nuorder-full";
import { DATATEST } from "constants/integration";

interface IFooterProps {
    model?: any;
}

interface IFooterState {
    showRequestAccess: boolean;
    showContacts: boolean;
}

export class Footer extends React.Component<IFooterProps, IFooterState> {
    styles = {
        contact: merge(
            {
                display: "block",
                position: "fixed",
                zIndex: 7,
                bottom: "0px",
                left: "0px",
                right: "0px",
                height: "80%",
                background: "rgba(0,0,0,.7)",
                padding: "0 10%",
            },
            $(" .contactsHeader", {
                padding: "30px 0px",
                borderBottom: "1px solid #fff",
                paddingBottom: "20px",
                color: "#F0F0F0",
            }),
            $(" .contactsContainer", {
                height: "calc(100% - 30px)",
            }),
            $(" .headline", {
                fontFamily: "Cardo,serif",
                fontSize: "34px",
                fontWeight: "100",
                display: "inline",
                letterSpacing: "1px",
                textTransform: "none",
            }),
            $(" .aside", {
                marginLeft: "10px",
                textTransform: "uppercase",
                fontFamily: "Cardo, sans-serif",
                letterSpacing: "2px",
                fontSize: "16px",
            }),
        ),
        footer: merge(
            {
                display: "block",
                position: "fixed",
                zIndex: 2,
                bottom: "0px",
                left: "0px",
                right: "0px",
                height: "180px",
                background: "linear-gradient( 180deg, rgba(0,0,0, 0), rgba(0,0,0, .6))",
            },
            $(" a", {
                position: "absolute",
                right: "10%",
                top: "44%",
            }),
            $(" a i", {
                position: "relative",
                fontSize: "80%",
                paddingRight: "4px",
            }),
            $(" .buttonHolder", {
                position: "absolute",
                right: "8%",
                width: "84%",
                bottom: "36px",
            }),
            media(
                presets.phablet,
                merge(
                    $(" .buttonHolder", {
                        right: "16px",
                        width: "240px",
                        bottom: "36px",
                    }),
                ),
            ),
        ),
    };

    constructor(props) {
        super(props);
        this.state = {
            showRequestAccess: false,
            showContacts: false,
        };
    }

    handleShowContacts = () => {
        this.setState({ showContacts: true });
    };

    handleHideContacts = () => {
        this.setState({ showContacts: false });
    };

    handleRequestAccess = (e) => {
        e.preventDefault();
        this.setState({ showRequestAccess: true });
    };

    handleShowRequestAccess = () => {
        this.setState({ showRequestAccess: false });
    };

    render() {
        const { model } = this.props;
        const { showRequestAccess, showContacts } = this.state;

        if (model && showContacts) {
            return (
                <footer {...this.styles.contact}>
                    <div data-test={DATATEST.LOGIN.CONTACT_REP_HEADER} className="contactsHeader">
                        <h1 className="headline">{model.brand_name}</h1>
                        <span className="aside">{"//"}</span>
                        <span className="aside">{formatMessage("Sales Contacts")}</span>
                        <FlatButton
                            data-test={DATATEST.DIALOG.CLOSE}
                            label={formatMessage("Close")}
                            style={{
                                position: "absolute",
                                right: "10%",
                                color: "#fff",
                            }}
                            onClick={this.handleHideContacts}
                        />
                    </div>
                    <div className="contactsContainer">
                        <MarketplaceContacts model={model} />
                    </div>
                </footer>
            );
        }

        return (
            <footer {...this.styles.footer}>
                <div {...merge({ display: "none" }, media(presets.phablet, { display: "inline-block" }))}>
                    <Nuorder color="white" style={{ width: "206px", height: "unset", margin: "104px 0 0 36px" }} />
                </div>
                <div className="buttonHolder">
                    {model && <ContactButton model={model} onShowContacts={this.handleShowContacts} />}
                    {model && <RequestAccessButton model={model} onRequestOpen={this.handleRequestAccess} />}
                </div>
                {model && (
                    <RequestAccess
                        open={showRequestAccess}
                        model={model}
                        onRequestClose={this.handleShowRequestAccess}
                    />
                )}
            </footer>
        );
    }
}

export default Footer;
